import { Typography } from '@mui/material';
import { concat, get } from 'lodash';
import React, { FC } from 'react';
import CreateForm from 'src/components/ui-component/form-component/create-form/CreateForm';
import { useApplication } from 'src/context/ApplicationContext';
import { ALS_ERLEDIGT_MARKIEREN_LABEL, FORM_FIELDS_TYPES, LOEWE_IMAGE_UPLOAD_FIELD_PROPS } from 'src/lib/constants/constant';
import { FormStrucItem } from 'src/lib/types/types';
import { ForceTrue } from 'src/lib/validation/ValidationTypes';
import PruefAssistenz from 'src/pages/private/online-antrag/antrag-components/PruefAssistenz';
import ApplicationHeading from 'src/pages/private/online-antrag/application-heading/ApplicationHeading';
import { checkIfPruefAssitenzNeedsToValidate } from 'src/pages/private/online-antrag/application-helper-function/AppHelperfunctions';
import { getFormStrucWithoutComponentTable, mapindexbyPath } from 'src/utils/formStruc';
import { addIndexToPath, checkReadOnlyInUeberarbeitung } from 'src/utils/helper';

// import schemas
import AntragSchema from 'src/lib/paths/antrag_FULL_Paths.json';
import { getTextFieldValidationByDatei } from 'src/lib/validation/fieldValidationHelper';
const P = AntragSchema.attributes;

const EntwicklungsvVorhabenSkizzeLoewe: FC<{ hasComment?: boolean }> = ({ hasComment }) => {
	const { application, setApplicationProperty, readOnly } = useApplication();
	const updatedReadOnly = checkReadOnlyInUeberarbeitung(application, readOnly, hasComment);
	return (
		<>
			<PruefAssistenz
				statusPath={P.Projektbeschreibung_Loewe.schema.attributes.Pruefung_Technologisch_Pruefstatus.path}
				hinweisPath={P.Projektbeschreibung_Loewe.schema.attributes.Pruefung_Technologisch_Hinweis_Fuer_Den_Antragsteller.path}
				ueberarbeitetAmPath={P.Projektbeschreibung_Loewe.schema.attributes.Pruefung_Technologisch_Ueberarbeitet_Am.path}
				erledigtPath={P.Projektbeschreibung_Loewe.schema.attributes.Pruefung_Technologisch_Erledigt.path}
				formStruc={formStrucPruefAssistenz()}
			/>
			<ApplicationHeading title={'Technologische Beschreibung des zu entwickelnden Produkts oder Prozesses'} />
			<Typography>
				<strong>Bitte gehen Sie u.a. auf folgende Bereiche ein:</strong> Beschreibung des angestrebten Projektziels und des technologischen
				Entwicklungsstands (Prototyp, Demonstrator, Vorserie) inkl. beispielhafter Funktionsbeschreibung; Darlegung des wissenschaftlichen und
				wirtschaftlichen Risikos.
			</Typography>
			<CreateForm formStruc={formStruc()} formValues={application} updateFormValuesFunc={setApplicationProperty} readOnly={updatedReadOnly} />
		</>
	);
};

export default EntwicklungsvVorhabenSkizzeLoewe;

const formStrucPruefAssistenz = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Projektbeschreibung_Loewe.schema.attributes.Pruefung_Technologisch_Erledigt,
					label: ALS_ERLEDIGT_MARKIEREN_LABEL,
					validation: [{ validateFunction: ForceTrue }],
				},
			],
		},
	];
	return struc;
};
const formStruc = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{ ...P.Projektbeschreibung_Loewe.schema.attributes.Projektziel_Und_Entwicklungsstand_Skizze, maxCharLength: 5500, hideLabel: true },
				{
					...P.Projektbeschreibung_Loewe.schema.attributes.Entwicklungsvorhaben_Bilder,
					type: FORM_FIELDS_TYPES.editableTable,
					...LOEWE_IMAGE_UPLOAD_FIELD_PROPS,
				},
			],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];
	return struc;
};

const customFormStruc = (application: any, i: number) => {
	const datei = get(
		application,
		addIndexToPath(
			P.Projektbeschreibung_Loewe.schema.attributes.Entwicklungsvorhaben_Bilder.schema.attributes.Bild.path,
			i,
			P.Projektbeschreibung_Loewe.schema.attributes.Entwicklungsvorhaben_Bilder.path,
		),
	);
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Projektbeschreibung_Loewe.schema.attributes.Entwicklungsvorhaben_Bilder.schema.attributes.Bildunterschrift_Titel,
					validation: getTextFieldValidationByDatei(datei),
				},
				{
					...P.Projektbeschreibung_Loewe.schema.attributes.Entwicklungsvorhaben_Bilder.schema.attributes.Copyright_Hinweise,
					validation: getTextFieldValidationByDatei(datei),
				},
				{
					...P.Projektbeschreibung_Loewe.schema.attributes.Entwicklungsvorhaben_Bilder.schema.attributes.Kurzbeschreibung,
					validation: getTextFieldValidationByDatei(datei),
				},
			],
		},
	];
	return struc;
};

export const getFormStrucEntwicklungsvVorhabenSkizzeLoewe = (application: any) => {
	let result: FormStrucItem[] = [];
	const bilderLength = get(application, P.Projektbeschreibung_Loewe.schema.attributes.Entwicklungsvorhaben_Bilder.path, []).length;

	//check if there are images, if yes then validate the additional fields for each image
	for (let i = 0; i < bilderLength; i++) {
		//map customFOrmStruc with index to each path
		const customFormStrucWithIndex = mapindexbyPath(
			customFormStruc(application, i),
			i,
			P.Projektbeschreibung_Loewe.schema.attributes.Entwicklungsvorhaben_Bilder,
		);
		result = concat(result, customFormStrucWithIndex);
	}

	if (
		checkIfPruefAssitenzNeedsToValidate(
			application,
			P.Projektbeschreibung_Loewe.schema.attributes.Pruefung_Technologisch_Pruefstatus.path,
			P.Projektbeschreibung_Loewe.schema.attributes.Pruefung_Technologisch_Erledigt.path,
		)
	) {
		result = concat(result, formStrucPruefAssistenz());
	}
	result = concat(result, getFormStrucWithoutComponentTable(formStruc()));

	return result;
};
